import DocumentIcon from "assets/img/documents/document.svg?react";
import { Button } from "components/elements/Button";

export const NothingHere = () => {
    return (
        <div className="flex h-4/6 flex-col items-center justify-center rounded-2xl border border-[#c8c8c8] bg-white p-14 text-center">
            <div className="mb-4">
                <div className="">
                    <DocumentIcon className="" />
                </div>
            </div>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">Nothing to see here</h2>
        </div>
    );
};
